<template>
	<div class="page">
		<div class="page-left"></div>
		<div class="page-right">
			<div class="title">惠企服务平台</div>
			<div class="tip" @click="toRegister">没有账号？去注册一个 >></div>
			<div class="form-item">
				<div>
					<img class="icon-login" src="@/assets/login/name.png" />
					<input maxlength="12" v-model="form.username" placeholder="请输入手机号" />
				</div>
			</div>
			<div class="form-item">
				<div>
					<img class="icon-login" src="@/assets/login/pwd.png" />
					<input maxlength="20" v-model="form.password" placeholder="请输入密码" :type="!showPassword ? 'password': 'text'" />
					<img class="password-eye" @click="showPassword = !showPassword" :src="showPassword ? require('@/assets/eye.png') : require('@/assets/eye-close.png')" alt="eye">
				</div>
			</div>
			<div class="form-item">
				<div class="big-item">
					<img class="icon-login" src="@/assets/login/yzm.png" />
					<input maxlength="4" v-model="form.captcha" @keyup.enter="login" placeholder="请输入验证码" />
				</div>
				<img :src="imageUrl" :style="{ cursor: 'pointer', border: '1px solid #333' }" class="yzm-img" @click="getRandomImage" />
			</div>
			<div class="miss_layout">
				<div class="missMess" @click="$router.push({ path: '/changeroot' })">忘记账号</div>
				<div class="missMess" @click="$router.push({ path: '/changepwd' })">忘记密码</div>
			</div>
			<Button class="login-btn" type="primary" :loading="loading" @click="throttle(login(),300)">登录</Button>
		</div>
	</div>
</template>

<script>
import lodash from "lodash";
import { getAction, postAction } from "@/util/require.js";
import { Message } from "ant-design-vue";
const { throttle } = lodash;
export default {
	name: "",
	components: {},
	data() {
		return {
			form: {},
			imageUrl: "",
			loading: false,
			showPassword: false,
		};
	},
	created() {
		this.getRandomImage();
	},
	mounted() {},
	methods: {
		// 防抖
		throttle,
		toRegister() {
			this.$router.push({ path: "/register" });
		},
		getRandomImage() {
			this.form.checkKey = new Date().getTime();
			getAction(`/hq/webPage/randomImage/${this.form.checkKey}`).then((res) => {
				console.log("sddd", res);
				if (res.success) {
					this.imageUrl = res.result;
				}
			});
		},
		login() {
			if (!this.form.username) {
				Message.warning("请输入手机号");
				return;
			}
			if (!this.form.password) {
				Message.warning("请输入密码");
				return;
			}
			if (!this.form.captcha) {
				Message.warning("请输入验证码");
				return;
			}
			this.loading = true;
			postAction("/hq/webPage/login", {
				...this.form,
			})
				.then((res) => {
					if (res.success) {
						Message.success(res.message);
						localStorage.setItem("token", res.result.token);
						localStorage.setItem("userInfo", JSON.stringify(res.result.userInfo));
						this.$router.push({ path: "/" });
					} else {
						this.getRandomImage();
					}
				})
				.finally((res) => {
					this.loading = false;
				});
		},
	},
};
</script>

<style scoped lang="scss">
.page {
	overflow: hidden;
	position: relative;
	height: 10.9rem;
	max-height: 100vh;
	.page-left {
		position: absolute;
		width: 14.8rem;
		height: 10.8rem;
		background: url("~@/assets/login/loginBg.png") 0 0/14.8rem 10.8rem no-repeat;
	}
}

.miss_layout {
	width: 5.2rem;
	height: 0.4rem;
	display: flex;
	margin-top: 0.3rem;
	align-items: center;
	justify-content: flex-end;

	.missMess {
		font-size: 16px;
		cursor: pointer;
		color: #087ce8;
        margin-left: 30px;
	}
}

.page-right {
	position: absolute;
	left: 10.2rem;
	top: 2.8rem;
	.title {
		font-size: 0.4rem;
		font-weight: bold;
		color: #1a2e40;
	}
	.tip {
		cursor: pointer;
		margin-top: 0.2rem;
		font-size: 0.24rem;
		font-family: PingFang SC;
		font-weight: 400;
		color: #087ce8;
	}
}
.form-item {
	width: 5.2rem;
	height: 0.4rem;
	display: flex;
	margin-top: 0.3rem;
	align-items: center;
	justify-content: space-between;
	position: relative;
}

.password-eye {
	position: absolute;
	right: 0.1rem;
	top: 50%;
	transform: translateY(-50%);
	width: 0.3rem;
	height: 0.3rem;
	cursor: pointer;
}

.big-item {
	width: 3.5rem !important;
}
.form-item > div {
	width: 5.2rem;
	height: 0.5rem;
	border-bottom: 1px solid #eeeeee !important;
	display: flex;
	align-items: center;
}
.form-item > div input {
	width: 100%;
	height: 0.4rem;
	border: none !important;
	outline: none !important;
	margin-left: 0.1rem;
	font-size: 0.2rem;
	font-family: PingFang SC;
}
.yzm-img {
	width: 1.5rem;
	height: 0.5rem;
	display: block;
}
.login-btn {
	width: 1.8rem;
	height: 0.5rem;
	background: #087ce8;
	border-radius: 0.04rem;
	font-size: 0.24rem;
	font-family: PingFang SC;
	font-weight: bold;
	color: #ffffff;
	text-align: center;
	line-height: 0.5rem;
	cursor: pointer;
	margin-top: 0.5rem;
}
</style>
